import react from 'react';

import { ModalProps } from '@material-ui/core/Modal';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';

import Wallet from '../plugin/Wallet';
import tokens from '../plugin/config/tokens';

import PopupRegisterTokenItem from './popup-register-token-item';

type PopupRegisterTokenProps = {
  wallet:Wallet;
  open:boolean;
  handleClose:ModalProps['onClose'];
};

const PopupRegisterToken: react.FC<PopupRegisterTokenProps> = ({ wallet, open = false, handleClose }) => {
  return (
    <Dialog className="popup-register-token" open={open} onClose={handleClose}>
      <DialogTitle>Add Token</DialogTitle>
      <List>
        {tokens.map(token => (
          <PopupRegisterTokenItem key={token.id} wallet={wallet} token={token} />
        ))}
      </List>
    </Dialog>
  );
};

export default PopupRegisterToken;
